// https://github.com/IdentityModel/oidc-client-js

export interface Logger {
  error(message?: any, ...optionalParams: any[]): void;
  info(message?: any, ...optionalParams: any[]): void;
  debug(message?: any, ...optionalParams: any[]): void;
  warn(message?: any, ...optionalParams: any[]): void;
}

const noOpLogger: Logger = {
  debug() {},
  info() {},
  warn() {},
  error() {}
};

export class Log {
  static readonly NONE = 0;
  static readonly ERROR = 1;
  static readonly WARN = 2;
  static readonly INFO = 3;
  static readonly DEBUG = 4;

  static level: number = Log.WARN;
  static logger: Logger;

  static reset() {
    this.level = Log.INFO;
    this.logger = noOpLogger;
  }

  static debug = (...msg: any[]) => {
    if (Log.level >= Log.DEBUG) {
      Log.logger.debug('DEBUG:', ...msg);
    }
  };

  static info = (...msg: any[]) => {
    if (Log.level >= Log.INFO) {
      Log.logger.info('INFO:', ...msg);
    }
  };

  static warn = (...msg: any[]) => {
    if (Log.level >= Log.WARN) {
      Log.logger.warn('WARN:', ...msg);
    }
  };

  static error = (...msg: any[]) => {
    if (Log.level >= Log.ERROR) {
      Log.logger.error('ERROR:', ...msg);
    }
  };
}

export const ConfigureLogger = (level: number, logger: Logger = console) => {
  Log.level = level;
  Log.logger = logger;
};

Log.reset();
